import React, { useEffect, useState } from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from "saur_ui_library/src/Atoms/Word/Word";
import Card from 'saur_ui_library/src/Molecules/Card/Card';
import {
  getInfoBulleMessage,
  getOptionsCommunes,
  getOptionsInstalls,
  resetImputLabel,
  resetOptions,
} from '../../../utils/helpers/module/filtersHelper';
import { colorFormated } from '../../../utils/helpers/module/moduleComponentHelper';
import Legend from '../../common/component/Legend';
import DoubleFilter from '../component/DoubleFilter';
import SingleFilter from '../component/SingleFilter';
import { useLocation } from 'react-router-dom';
import DataSelector from '../../common/component/dataSelector';
import { defineDefinitionExpression } from '../../../utils/helpers/map/defExpHelper';
import { typeOptionsMilieuSensibility } from '../options/optionsHelper';
import { getLayerIdForRequest } from '../../../utils/helpers/module/milieuHelper';
import { loaderDataComponent } from '../../../utils/helper';

const FiltersMilieu = (props: any) => {
  const contractCode = window.sessionStorage.getItem('contractCode') || '';
  const [fonctionnement, setFonctionnement] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('milieu_color_'+props.option)!) || ''
  );  
  // const for dropdownlist on change
  const [commune, setCommune] = useState<any>(
    JSON.parse(
      window.sessionStorage.getItem('milieu_commune_' + props.option)!
    ) || {
      name: '',
      code: '',
    }
  );
  const [type, setType] = useState<any>(
    JSON.parse(
      window.sessionStorage.getItem('milieu_type_' + props.option)!
    ) || {
      name: '',
      code:
        props.option === 'sensibility'
          ? "MDI_DO', 'MDI_PR', 'MDI_PR,TP', 'MDI_SE"
          : 'MDI_SE',
    }
  );
  const [installations, setInstallations] = useState<any>(
    JSON.parse(
      window.sessionStorage.getItem('milieu_installation_' + props.option)!
    ) || {
      name: '',
      code: '',
    }
  );
  // const for dropdownlists options
  const [communeOptions, setCommuneOptions] = useState<any>([]);
  const [installsOptions, setInstallsOptions] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [fieldNameColor, ] = useState<string>(
    props.option === 'sensibility' ? 'SensibilityColor' : 'DilutionColor'
  );

  const infoBulleMessageDataSelectorMilieu = getInfoBulleMessage(props.module);

  const location = useLocation();
  // The current location.
  window.sessionStorage.setItem("location", location.pathname);

  // get communes options
  const getCommune = async () => {
    const optionsCommune = await getOptionsCommunes(
      contractCode,
      getLayerIdForRequest(props.option),
      props.module
    );
    if (optionsCommune.length === 0) {
      resetImputLabel('milieu-filtre-commune-' + props.option);
    }
    setCommuneOptions(optionsCommune);
  };

  // get installs options
  const getInstall = async (
    pFilters: any
  ) => {
    const res = await getOptionsInstalls(
      defineDefinitionExpression(pFilters, 'modules', contractCode),
      getLayerIdForRequest(props.option)
    );
    if (res.length === 0) {
      resetImputLabel('milieu-filtre-installation-' + props.option);
    }
    setInstallsOptions(res);
  };

  // trigger dynamic dropdownlists hence on change (commune, type and deversement)
  useEffect(() => {
    if (loading === false) {
      setLoading(true);
      getInstall({
        [fieldNameColor]: colorFormated(fonctionnement),
        InseeCode: commune,
        ModelCode: type,
      }).then(() => {
        setLoading(false);
      });
    }
  }, [commune, type, fonctionnement]); // eslint-disable-line react-hooks/exhaustive-deps

  // component did mount
  useEffect(() => {
    // load memory and launch table and map
    props.parentCallback({
      [fieldNameColor]: fonctionnement,
      InseeCode: commune,
      ModelCode: type,
      Code: installations,
    });
    setLoading(true);
    getCommune().then(() => {
      setLoading(false);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Container className='filterForm'>
      <Card automatedTestId={props.module + '-filter'}>
        <Word
          value='FILTRER MA RECHERCHE'
          textStyle='title'
          variant='h1'
          automatedTestId='search-word'
        />
        <Legend type={localStorage.getItem('type')!} option={props.option} />
        <Container className='deversement'>
          <Word
            value='Qualité du milieu'
            textStyle='normalReg'
            variant='p'
            automatedTestId='id-quality-milieu'
          />
          <DataSelector
            infoBulles={infoBulleMessageDataSelectorMilieu}
            sendSelectedColor={(d: any) => {
              setFonctionnement(d);
              fonctionnement !== '' &&
                props.parentCallback({
                  [fieldNameColor]: d,
                  InseeCode: commune,
                  ModelCode: type,
                  Code: installations,
                });
              window.sessionStorage.setItem(
                'milieu_color_' + props.option,
                JSON.stringify(d)
              );
            }}
            type='standard'
            sessionStorageName={'milieu_color_' + props.option}
          />
        </Container>
        {commune !== null && (
          <DoubleFilter
            module='milieu'
            option={props.option}
            titleOne='Communes :'
            filterNameOne={'commune_' + props.option}
            filterOneOptions={communeOptions}
            titleTwo='Types :'
            filterNameTwo={'type_' + props.option}
            filterTwoOptions={typeOptionsMilieuSensibility}
            parentCallbackOne={(d) => {
              setCommune(d);
              resetOptions(
                d,
                'milieu-filtre-installation-' + props.option,
                setInstallsOptions
              );
              props.parentCallback({
                [fieldNameColor]: fonctionnement,
                InseeCode: d,
                ModelCode: type,
                Code: installations,
              });
            }}
            parentCallbackTwo={(d) => {
              setType(d);
              resetOptions(
                d,
                'milieu-filtre-installation-' + props.option,
                setInstallsOptions
              );
              props.parentCallback({
                [fieldNameColor]: fonctionnement,
                InseeCode: commune,
                ModelCode: d,
                Code: installations,
              });
            }}
          />
        )}
        {installations !== null && (
          <SingleFilter
            module='milieu'
            title='Installations :'
            filterName={'installation_' + props.option}
            filterOptions={installsOptions}
            parentCallback={(d) => {              
              setInstallations(d);
              props.parentCallback({
                [fieldNameColor]: fonctionnement,
                InseeCode: commune,
                ModelCode: type,
                Code: d,
              });
            }}
          />
        )}
        {loaderDataComponent(loading)}
      </Card>
    </Container>
  );
};
export default FiltersMilieu;
